import { connect } from 'react-redux';

import IpStatistics from '../../components/sider/ip-statistics';

export default connect()(IpStatistics);



// WEBPACK FOOTER //
// ./containers/sider/ip-statistics.js